import { render, staticRenderFns } from "./TransactionSummary.vue?vue&type=template&id=2a3fa642&scoped=true&"
import script from "./TransactionSummary.vue?vue&type=script&lang=js&"
export * from "./TransactionSummary.vue?vue&type=script&lang=js&"
import style0 from "./TransactionSummary.vue?vue&type=style&index=0&id=2a3fa642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3fa642",
  null
  
)

export default component.exports